import { WidgetType } from './widgetType';
export const TextOnImageWidgetHelper = {
    isTextOnImageWidget: (widget) => {
        return widget.value.type === WidgetType.textOnImage;
    },
    isTextOnImageServerData: (widget) => {
        return widget.type === WidgetType.textOnImage;
    },
    makeDefaultProperties: () => ({
        displayDelayInSeconds: 0,
        overlayOpacity: 50,
        overlayColor: '#000000',
    }),
};
